module.exports = __webpack_public_path__ + "media/Images/about-figure-001-e7965c4a6c07cee8f44574bb9138baa8.png";